import styled from 'styled-components';
import { SButton } from '../styles/Button.styled';

export const SModalTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 40px;
  color: ${({ theme }) => theme.colors.primaryText};
  margin-bottom: 10px;
`;

export const SModalCheckboxContainter = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  width: 100%;

  .inner-container {
    width: 33%;
    .standalone-search-border {
      padding: 15px;
      border-radius: 0;
      border: 2px solid ${({ theme }) => theme.colors.primaryText};

      > * {
        margin-top: 10px;
      }
    }
    > * {
      margin-top: 10px;
    }
  }
`;

export const SActionButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;

  &.single {
    justify-content: flex-end;
  }

  ${SButton} {
    flex-basis: 50%;

    + ${SButton} {
      margin-left: 10px;
    }
  }
`;

export const SLabel = styled.div`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 12.5px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.medium};
  letter-spacing: 0;
  margin-top: 10px;
  position: relative;
  white-space: nowrap;
  width: 66.66%;
  display: inline-block;
`;

export const SLabelStandAlone = styled.div`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 12.5px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.medium};
  letter-spacing: 0;
  margin-top: 10px;
  position: relative;
  white-space: nowrap;
  width: 33.33%;
  display: inline-block;
`;
